import React from 'react';
import { Hero } from '../components/Hero';
import { Manifesto } from '../components/Manifesto';
import { SocialProofOpener } from '../components/SocialProofOpener';
import { PainPoints } from '../components/PainPoints';
import { FinalCTA } from '../components/FinalCTA';
export function HomePage() {
  return <>
      <Hero data-id="element-568" />
      <Manifesto data-id="element-569" />
      <SocialProofOpener data-id="element-570" />
      <PainPoints data-id="element-571" />
      <FinalCTA data-id="element-572" />
    </>;
}